module.exports = __webpack_public_path__ + "static/media/Validation1.587e28db.png";